import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const UsagePricingDataTableContainer = styled.div`
    display: flex;
    width: 100%;
    ${media.mobileDevice`
        display: none;
    `}
`;

export const UsagePricingCardContainer = styled.div`
    display: none;
    width: 100%;
    ${media.mobileDevice`
        display: flex;
        flex-direction: column;
    `}
`;

export const UsagePricingContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: space-between;
`;
export const UsagePricingFullWidth = styled.div`
    display: flex;
    width: 100%;
`;

export const UsagePricingDataContainer = styled.div`
    display: flex;
    height: ${({ height }) => (height ? height : 'auto')};
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    width: ${({ width }) => (width ? width : '100%')};
    margin: ${({ margin }) => (margin ? margin : '0')};
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'flex-start'};
    align-items: ${({ alignItems }) => alignItems};
    padding: ${({ padding }) => (padding ? padding : '0')};
`;

export const UsagePriceFont = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    display: inline-block;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    color: ${({ color }) => (color ? color : '#000000')};
    text-decoration: ${({ textDecoration }) =>
        textDecoration ? textDecoration : 'none'};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '0px'};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '20px')};
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    opacity: 1;
`;

export const Type = styled.span`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: inline;
    padding-left: 5px;
    padding-right: 5px;
    margin-left: 5px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #140f4b;
    opacity: 1;
    font-size: 13px;
`;

export const UsagePricingSummary = styled.div`
    display: flex;
    width: 100%;
`;

export const UsagePricingTableFont = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    display: ${({ display }) => (display ? display : 'inline-block')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
    color: ${({ color }) => (color ? color : '#000000')};
    text-decoration: ${({ textDecoration }) =>
        textDecoration ? textDecoration : 'none'};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '0px'};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '20px')};
    opacity: 1;
    text-overflow: ${({ textOverflow }) => textOverflow};
    overflow: ${({ overflow }) => overflow};
    text-align: ${({ textAlign }) => textAlign};
    cursor: ${(props) => (props.cursor ? props.cursor : 'auto')};
    -webkit-line-clamp: ${({ lineClamp }) => lineClamp};
    -webkit-box-orient: ${({ orient }) => orient};
    word-break: ${({ wordBreak }) => wordBreak};
    height: ${({ descHeight }) => descHeight};
    ${media.mobileDevice`
        font-size: ${({ mobileFontSize }) =>
            mobileFontSize ? mobileFontSize : '14px'};
        height: auto;
    `}
`;
export const AdjustmentProductContainer = styled.div`
    display: flex;
    margin: ${({ margin }) => (margin ? margin : '0')};
    width: 100%;
    height: 100%;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    justify-content: ${({ justifyContent }) => justifyContent};
    align-items: ${({ alignItems }) => alignItems};
`;

export const MainContainerItems = styled.div`
    width: ${({ width }) => (width ? width : '47%')};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};

    ${media.largeDevice`
        width:${({ ldWidth }) => ldWidth && ldWidth};
        padding: ${({ ldPadding }) => (ldPadding ? ldPadding : '0rem')};
    `}

    ${media.mediumDevice`
        padding: ${({ mdPadding }) => (mdPadding ? mdPadding : '0rem')};
    `}

    ${media.smalDevice`
        padding: ${({ ipadPadding }) => (ipadPadding ? ipadPadding : '0.5rem')};
    `}
    ${media.mobileDevice`
        width: 100%;
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : '0rem')};     
    `}
`;
